// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class NotificationTypeScopeNestedResource extends Resource {
    basePath: string = 'notifications/notification-types-scopes/{parent}/scope/';

    objectPath: string = 'notifications/notification-types-scopes/{parent}/scope/{ident}/';
}
